<template>
	<div class="add-sub container-fluid">
		<div class="row">
			<div class="block highlighted-content">
				<!-- <div class="setting"> -->
				<!-- <h6 class="text-uppercase">{{ 'Complexity' | translate }}</h6> -->

				<button @click="startGame(50)" class="btn btn-lg btn-success">
					{{ 'Start' | translate }}
				</button>

				<!-- <div @click="$router.go(-1)" class="text-uppercase btn btn-pink">
			{{ 'Back' | translate }}
		</div> -->
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'multiply_25x25',
	data() {
		return {
			prevRoute: null
		}
	},
	computed: {
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
	methods: {
		startGame(complexity) {
			let data = {
				type: 'multiply_25x25',
				complexity,
				withSound: false,
			}
			this.$store.commit('changeGameConfig', data)
			this.$router.push({ path: '/games/game' })
		},
	},
	beforeRouteEnter(to, from, next) {
		next(vm => vm.prevRoute = from.path)
	},
	watch: {
		prevRoute(value) {
			if (value?.includes('games/game')) {
				this.$router.push({
					path: "/dashboard-student/training",
					query: {
						'menu': "multiply",
					}
				})
			} else {
				this.startGame(50)
			}
		}
	}
}
</script>

<style scoped lang="scss">
.setting {
	text-align: center;
	text-transform: uppercase;
}

.btn-secondary {
	width: 150px;
	display: block;
	margin: 15px auto;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 10px 15px;
	cursor: pointer;
	// width: 150px;
}

.btn-pink:hover {
	background-color: #e85183;
}

.block {
	display: block;
	// grid-template-columns: 40% 60%;
	// grid-gap: 15px;

	width: fit-content;
	padding: 0;
	margin: auto;

	margin-top: 50px;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		// border: 2px solid red;
		color: #212529;

		box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);
	}

	& h6 {
		margin: 0;
	}

	@media (max-width: 767px) {
		display: block;
		text-align: center;
	}
}
</style>
